/* THE NELCO - basketball reward: 10 in a row unlocks a one-time 10% code. Does not touch game difficulty. */
(function(){
  var FN="https://ddntnfpfanpckiqypdqn.supabase.co/functions/v1/nelco-game-reward";
  var KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkbnRuZnBmYW5wY2tpcXlwZHFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODg0MDk1NjksImV4cCI6MjEwMzk4NTU2OX0.qVm_XFwbC-GbCxY0BSi0E9NIbo7vfddLPR3dMkJJyd8";
  var TARGET=10, LS="nelcoRewardCode";
  var streakEl=document.getElementById("bStreak"), scoreEl=document.getElementById("bScore");
  if(!streakEl||!scoreEl)return;

  var css=".nr-banner{display:flex;align-items:center;gap:14px;background:#0B0D12;color:#fff;border-radius:22px;padding:16px 18px;margin:22px 0 18px;box-shadow:0 10px 30px rgba(0,0,0,.18)}"+
  ".nr-badge{flex:0 0 auto;background:#D8FF5E;color:#0B0D12;font-family:Anton,Impact,sans-serif;font-size:26px;line-height:1;padding:10px 12px;border-radius:14px}"+
  ".nr-txt{flex:1;min-width:0}.nr-t{font-family:Anton,Impact,sans-serif;font-size:20px;letter-spacing:.02em;line-height:1.1;text-transform:uppercase}"+
  ".nr-s{font-family:Manrope,sans-serif;font-size:13px;opacity:.75;margin-top:4px}"+
  ".nr-bar{height:6px;background:rgba(255,255,255,.15);border-radius:6px;margin-top:10px;overflow:hidden}.nr-fill{height:100%;width:0;background:#D8FF5E;border-radius:6px;transition:width .35s}"+
  ".nr-back{position:fixed;inset:0;background:rgba(11,13,18,.72);display:none;align-items:center;justify-content:center;padding:20px;z-index:9999;backdrop-filter:blur(4px)}.nr-back.on{display:flex}"+
  ".nr-card{background:#fff;color:#0B0D12;border-radius:26px;max-width:420px;width:100%;padding:28px 24px;position:relative;font-family:Manrope,sans-serif;text-align:center}"+
  ".nr-x{position:absolute;top:12px;right:14px;border:0;background:none;font-size:26px;cursor:pointer;color:#0B0D12}"+
  ".nr-h{font-family:Anton,Impact,sans-serif;font-size:34px;line-height:1;text-transform:uppercase;margin:6px 0 10px}"+
  ".nr-p{font-size:15px;opacity:.8;margin:0 0 18px}"+
  ".nr-in{width:100%;box-sizing:border-box;border:2px solid #0B0D12;border-radius:14px;padding:14px;font:600 16px Manrope,sans-serif;margin-bottom:12px}"+
  ".nr-btn{display:block;width:100%;box-sizing:border-box;border:0;border-radius:999px;padding:15px;font:800 16px Manrope,sans-serif;cursor:pointer;background:#0B0D12;color:#fff;text-decoration:none;margin-top:10px}"+
  ".nr-btn.lime{background:#D8FF5E;color:#0B0D12}.nr-btn[disabled]{opacity:.6;cursor:wait}"+
  ".nr-code{font-family:Anton,Impact,sans-serif;font-size:32px;letter-spacing:.06em;border:2px dashed #0B0D12;border-radius:16px;padding:14px;margin:6px 0 4px;user-select:all}"+
  ".nr-err{color:#c0392b;font-size:14px;min-height:18px;margin-top:6px}.nr-small{font-size:12px;opacity:.6;margin-top:12px}";
  var st=document.createElement("style");st.textContent=css;document.head.appendChild(st);

  /* banner: placed just above the scoreboard */
  var stats=scoreEl;while(stats.parentElement&&!stats.contains(streakEl))stats=stats.parentElement;
  var banner=document.createElement("div");banner.className="nr-banner";
  banner.innerHTML='<div class="nr-badge">10%</div><div class="nr-txt"><div class="nr-t">Sink 10 in a row. Unlock 10% off.</div>'+
    '<div class="nr-s">Hit 10 baskets back to back and win a one-time code for 10% off everything.</div>'+
    '<div class="nr-bar"><div class="nr-fill" id="nrFill"></div></div></div>';
  stats.parentNode.insertBefore(banner,stats);
  var fill=banner.querySelector("#nrFill");

  /* popup */
  var back=document.createElement("div");back.className="nr-back";back.setAttribute("role","dialog");back.setAttribute("aria-modal","true");
  back.innerHTML='<div class="nr-card"><button class="nr-x" aria-label="Close">&times;</button><div id="nrBody"></div></div>';
  document.body.appendChild(back);
  var body=back.querySelector("#nrBody");
  function close(){back.classList.remove("on")}
  back.querySelector(".nr-x").addEventListener("click",close);
  back.addEventListener("click",function(e){if(e.target===back)close()});

  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}

  function showCode(code){
    body.innerHTML='<div class="nr-h">Your code</div><p class="nr-p">10% off everything. Works on one order only.</p>'+
      '<div class="nr-code">'+esc(code)+'</div>'+
      '<button class="nr-btn" id="nrCopy">Copy code</button>'+
      '<a class="nr-btn lime" href="/discount/'+encodeURIComponent(code)+'?redirect=/collections/all">Shop with this code</a>'+
      '<div class="nr-small">If the discount is not applied automatically, paste the code at checkout.</div>';
    body.querySelector("#nrCopy").addEventListener("click",function(){
      var b=this;
      var done=function(){b.textContent="Copied";setTimeout(function(){b.textContent="Copy code"},1800)};
      if(navigator.clipboard)navigator.clipboard.writeText(code).then(done,done);else done();
    });
    back.classList.add("on");
  }

  function showForm(){
    body.innerHTML='<div class="nr-h">10 in a row!</div><p class="nr-p">You earned it. Enter your email to get your one-time 10% off code.</p>'+
      '<input class="nr-in" id="nrEmail" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com">'+
      '<button class="nr-btn lime" id="nrGo">Get my code</button><div class="nr-err" id="nrErr"></div>'+
      '<div class="nr-small">One code per email.</div>';
    var go=body.querySelector("#nrGo"),inp=body.querySelector("#nrEmail"),err=body.querySelector("#nrErr");
    function submit(){
      var email=inp.value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){err.textContent="Please enter a valid email address.";return}
      go.disabled=true;go.textContent="Checking...";err.textContent="";
      fetch(FN,{method:"POST",headers:{"Content-Type":"application/json","Authorization":"Bearer "+KEY,"apikey":KEY},body:JSON.stringify({email:email,streak:TARGET})})
        .then(function(r){return r.json()})
        .then(function(d){
          if(d.status==="ok"&&d.code){try{localStorage.setItem(LS,d.code)}catch(e){}showCode(d.code);return}
          var m={already_claimed:"This email has already claimed a reward code. Each email can win once.",
                 sold_out:"All reward codes have been claimed for now. Please check back soon.",
                 invalid_email:"Please enter a valid email address."}[d.status]||"Something went wrong. Please try again.";
          err.textContent=m;go.disabled=false;go.textContent="Get my code";
        })
        .catch(function(){err.textContent="Something went wrong. Please try again.";go.disabled=false;go.textContent="Get my code"});
    }
    go.addEventListener("click",submit);
    inp.addEventListener("keydown",function(e){if(e.key==="Enter")submit()});
    back.classList.add("on");
    setTimeout(function(){inp.focus()},50);
  }

  var fired=false;
  function onStreak(){
    var n=parseInt(streakEl.textContent,10)||0;
    fill.style.width=Math.min(n,TARGET)/TARGET*100+"%";
    if(n<TARGET){fired=false;return}
    if(fired)return;fired=true;
    var saved=null;try{saved=localStorage.getItem(LS)}catch(e){}
    if(saved)showCode(saved);else showForm();
  }
  new MutationObserver(onStreak).observe(streakEl,{childList:true,characterData:true,subtree:true});
  onStreak();
})();